import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './PreviousLecturerCard.css';
import {teamMemberPhoto} from '../../../../assets/symbols/images/teamMemberPhoto';
import {TLecturer} from '../../../../redux/timetable/timetable.type';
import {openWhatsApp} from '../../../../library/whatsApp';
import {getDateFormat, getTs} from '../../../../library/dates';

interface PreviousLecturerCardProps {
    lecturer: TLecturer;
    onAssign?: () => void;
}

function PreviousLecturerCard({lecturer, onAssign}: PreviousLecturerCardProps) {
    const {t} = useTranslation('timetable');
    const dataCy = `previous-lecturer-card-${lecturer.lid}`;
    const conferenceName = lecturer.lastEventName || undefined;
    const endedAt = lecturer.lastEventEnd ? getDateFormat(lecturer.lastEventEnd, 'DD.MM.YY') : undefined;
    const isEventActive = !!lecturer.lastEventEnd && lecturer.lastEventEnd >= getTs();

    return (
        <css.card data-cy={dataCy}>
            <css.body>
                <css.header>
                    <css.avatar $image={lecturer.image || teamMemberPhoto} />
                    <css.info>
                        <css.name dir="auto">{`${lecturer.firstName} ${lecturer.lastName}`.trim()}</css.name>
                        {conferenceName && <css.conference dir="auto">{conferenceName}</css.conference>}
                    </css.info>
                </css.header>

                <css.footer>
                    <css.footerRow>
                        {endedAt && <css.endedText dir="ltr">{`${t(isEventActive ? 'endsOn' : 'endedOn')} ${endedAt}`}</css.endedText>}
                        <css.contactButton
                            onClick={() => openWhatsApp(lecturer.phone || '', t('lecturerWhatsAppGreeting', {name: `${lecturer.firstName} ${lecturer.lastName}`.trim()}))}
                            aria-label={t('lecturerContact')}
                            disabled={!lecturer.phone}
                            data-cy={`${dataCy}-contact`}
                        >
                            <css.whatsAppIcon />
                        </css.contactButton>
                    </css.footerRow>
                    <css.assignButton onClick={onAssign} data-cy={`${dataCy}-assign`}>
                        {t('assignToConference')}
                    </css.assignButton>
                </css.footer>
            </css.body>
        </css.card>
    );
}

export default PreviousLecturerCard;
